import type { HeroSlide } from '@/types/movie';

export const heroSlides: HeroSlide[] = [
  {
    id: 'hero-star-return',
    movieId: 'star-return',
    backdrop: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20wide%20backdrop%20of%20a%20lone%20astronaut%20silhouette%20before%20a%20vast%20glowing%20violet%20and%20deep%20navy%20nebula%2C%20warm%20amber%20rim%20light%20on%20the%20edge%20of%20the%20figure%2C%20soft%20dark%20negative%20space%20on%20the%20left%20for%20text%2C%20epic%20sci-fi%20atmosphere%2C%20highly%20detailed%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    kicker: '本周首推 · 科幻巨制',
    headline: '星际归途',
    description: '当返航的坐标被时空扭曲，人类最后的机会握在一名领航员手中。',
  },
  {
    id: 'hero-cloud-city',
    movieId: 'cloud-city',
    backdrop: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20wide%20backdrop%20of%20a%20futuristic%20city%20skyline%20floating%20above%20a%20sea%20of%20clouds%20at%20golden%20sunrise%2C%20deep%20navy%20shadows%20and%20warm%20amber%20light%2C%20large%20soft%20negative%20space%20on%20the%20left%2C%20minimal%20modern%20sci-fi%20aesthetic%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
    kicker: '热播剧集 · 悬疑都市',
    headline: '云上之城',
    description: '云端新城的一桩数据泄露案，牵出整座城市不愿被提及的秘密。',
  },
  {
    id: 'hero-dream-traveler',
    movieId: 'dream-traveler',
    backdrop: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20wide%20backdrop%20of%20a%20surreal%20dream%20world%20with%20floating%20islands%2C%20glowing%20doorways%20and%20drifting%20light%20particles%2C%20deep%20navy%20and%20warm%20amber%20fantasy%20glow%2C%20spacious%20negative%20space%20on%20the%20left%20for%20text%2C%20whimsical%20and%20dreamy%2C%20highly%20detailed%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
    kicker: '奇幻冒险 · 全新上线',
    headline: '梦境旅人',
    description: '为了寻找失踪的哥哥，她走进了层层叠叠的他人梦境。',
  },
  {
    id: 'hero-throne-scheme',
    movieId: 'throne-scheme',
    backdrop: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20wide%20backdrop%20of%20an%20ancient%20Chinese%20imperial%20throne%20hall%20in%20soft%20golden%20light%20and%20deep%20navy%20shadow%2C%20drifting%20dust%20and%20mist%2C%20large%20dark%20negative%20space%20on%20the%20left%20for%20text%2C%20epic%20historical%20drama%20mood%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1600&height=900&seq=hero-slide-04&orientation=landscape',
    kicker: '口碑历史剧 · 高分',
    headline: '权谋之巅',
    description: '寒门学子卷入朝堂博弈，在权力的漩涡中，他选择守住初心。',
  },
  {
    id: 'hero-mist-detective',
    movieId: 'mist-detective',
    backdrop: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20wide%20backdrop%20of%20a%20foggy%20pine%20forest%20at%20dawn%20with%20a%20single%20glowing%20streetlight%20and%20a%20distant%20lone%20figure%2C%20deep%20navy%20blue%20mist%20and%20cool%20amber%20glow%2C%20ample%20negative%20space%20on%20the%20left%20for%20text%2C%20mysterious%20thriller%20atmosphere%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=hero-slide-05&orientation=landscape',
    kicker: '悬疑犯罪 · 全季上线',
    headline: '迷雾侦探',
    description: '浓雾小镇的连环失踪案，每一条线索都指向被刻意掩埋的真相。',
  },
];